// extracted by mini-css-extract-plugin
export var container = "style-module--container--32faf";
export var innerWrap = "style-module--innerWrap--6c80b";
export var link_totuka = "style-module--link_totuka--4482d";
export var link_tyuorinkan = "style-module--link_tyuorinkan--113a5";
export var number = "style-module--number--2e0f1";
export var tel = "style-module--tel--a2355";
export var txt = "style-module--txt--f530d";